import React from "react";
import { useResponsive } from "../../../../hooks/useResponsive";
import { getMilestoneProgressMetrics } from "./progressBarUtils";

function MilestoneProgressBar({
  allocatedHours,
  hoursSpent,
  exceedHours,
  remainingHours,
}) {
  const isMobile = useResponsive("down", "md");

  const dropzoneStyle = (width) => ({
    width: `${width}%`,
  });

  const metrics = getMilestoneProgressMetrics(
    allocatedHours,
    hoursSpent,
    exceedHours,
    remainingHours
  );

  return (
    <div>
      <div className="d-flex justify-content-space-between">
        <p className="complete-percent">
          {metrics.completedHours?.toFixed(2)}/{allocatedHours} hrs
        </p>
        <p className="complete-percent">{exceedHours} hrs</p>
      </div>
      <div className="milestone-progress-bar-main-container">
        <div
          className="milestone-progress-bar-section-1"
          style={{
            ...dropzoneStyle(metrics.greenPercentage),
          }}
        ></div>
        <div
          className="milestone-progress-bar-section-2"
          style={{
            ...dropzoneStyle(metrics.redPercentage),
          }}
        ></div>
      </div>
      <div className="d-flex justify-content-end">
        <p className="complete-percent">
          {metrics.completedPercentage}% Completed
        </p>
      </div>
    </div>
  );
}

export default MilestoneProgressBar;
